import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AccommodationsPane from 'src/components/global-settings/AccommodationsPane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    accomodations: state.vehicleCreateOptions.accommodations
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccommodationsPane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AccommodationsPane.ts